/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface DisableDailyUserUsageLimit200ResponseReissueOneOf1
 */
export interface DisableDailyUserUsageLimit200ResponseReissueOneOf1 {
    /**
     * 
     * @type {string}
     * @memberof DisableDailyUserUsageLimit200ResponseReissueOneOf1
     */
    'cardType': DisableDailyUserUsageLimit200ResponseReissueOneOf1CardTypeEnum;
    /**
     * Expiration date of the previous physical card that was replaced by automatic reissuance.
     * @type {string}
     * @memberof DisableDailyUserUsageLimit200ResponseReissueOneOf1
     */
    'expiredDate': string;
    /**
     * 
     * @type {boolean}
     * @memberof DisableDailyUserUsageLimit200ResponseReissueOneOf1
     */
    'isRenewalProcessing': boolean;
}

export const DisableDailyUserUsageLimit200ResponseReissueOneOf1CardTypeEnum = {
    physical: 'physical'
} as const;

export type DisableDailyUserUsageLimit200ResponseReissueOneOf1CardTypeEnum = typeof DisableDailyUserUsageLimit200ResponseReissueOneOf1CardTypeEnum[keyof typeof DisableDailyUserUsageLimit200ResponseReissueOneOf1CardTypeEnum];


